import { IntlShape } from 'react-intl';

import { sharedMessages } from './sharedMessages';

type PageMessageDto = {
  error: string;
  loading: string;
  showMoreButtonTitle: string;
  endOfList: string;
};

export const getPageMessages = (
  $t: IntlShape['$t'],
  overrides: Partial<PageMessageDto> = {}
): PageMessageDto => ({
  error: $t(sharedMessages.error),
  loading: $t(sharedMessages.loading),
  showMoreButtonTitle: $t(sharedMessages.showMoreButtonTitle),
  endOfList: $t(sharedMessages.endOfList),
  ...overrides,
});
